import { useState, ReactNode } from 'react';
import { SettingsContext } from '@contexts';
import type { Settings } from '@app-types';

interface SettingsProviderProps {
    children: ReactNode;
}

function SettingsProvider({ children }: SettingsProviderProps) {
    const [settings, setSettings] = useState<Settings | null>(null);
    const value = { settings, setSettings };
    return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
}

export default SettingsProvider;
